import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/quero-anunciar/cadastro")({
  beforeLoad: () => {
    throw redirect({
      to: "/minha-conta",
      search: { aba: "empresa" },
    });
  },
  component: () => null,
});
